/**
 * Smart weight formatting utility.
 * DB always stores in kg. Frontend adapts display based on magnitude.
 */

export type WeightUnit = 'kg' | 'g';

/** Format a weight_kg value for display, auto-choosing unit if <1 kg */
export function formatWeight(weightKg: number): string {
  const val = Number(weightKg);
  if (val < 1) {
    return `${Math.round(val * 1000)} g`;
  }
  // Remove trailing zeros: 5.00 -> 5, 5.50 -> 5.5
  return `${parseFloat(val.toFixed(2))} Kg`;
}

/** Determine if a set of weights should display in grams */
export function shouldUseGrams(weights: number[]): boolean {
  return weights.length > 0 && weights.every(w => w < 1);
}

/** Convert display value to kg for storage */
export function toKg(value: number, unit: WeightUnit): number {
  return unit === 'g' ? value / 1000 : value;
}

/** Convert kg to display value */
export function fromKg(weightKg: number, unit: WeightUnit): number {
  return unit === 'g' ? weightKg * 1000 : weightKg;
}

/** Suggest default unit based on a weight in kg */
export function suggestUnit(weightKg: number | null | undefined): WeightUnit {
  if (weightKg == null) return 'kg';
  return weightKg < 1 ? 'g' : 'kg';
}
